/**
 * AdminConfig
 * @author Simpli CLI generator
 */
import {Resource} from 'simpli-web-sdk'
import {sha256} from 'js-sha256'
import {Administrador} from '@/model/resource/Administrador'
import {InternationalRequest} from '@/helpers/InternationalRequest'

export class AdminConfigInternational extends Resource {
  idConfigPk: number = 0
  panelPassword: string | null = null
  updatedAt: string | null = null
  administrador: Administrador | null = null

  get $id() {
    return this.idConfigPk
  }
  set $id(val) {
    this.idConfigPk = val
  }

  get idAdministradorFk() {
    return this.administrador?.idAdministradorPk ?? 0
  }
  set idAdministradorFk(val) {
    if (this.administrador == null) this.administrador = new Administrador()
    this.administrador.idAdministradorPk = val
  }

  /**
   * Gets a instance of a given ID of AdminConfig
   */
  async getAdminConfig(id: number) {
    return await InternationalRequest.get(`/admin/admin-config/${id}`)
      .name('getAdminConfig')
      .as(this)
      .getData()
  }

  /**
   * Update a instance of AdminConfig.
   */
  async persistAdminConfig() {
    const request = this.$clone()
    request.panelPassword = this.panelPassword
      ? sha256(this.panelPassword)
      : null

    return await InternationalRequest.post(`/admin/admin-config`, request)
      .name('persistAdminConfig')
      .asNumber()
      .getData()
  }
}
